/** A backslash before ASCII punctuation is a markdown escape: the character is literal. */
const ESCAPED = /\\([!-/:-@[-`{-~])/g;
/** Escaped characters are parked in the Private Use Area so no rule below matches them. */
const PARK = 0xe000;
const PARKED = /[\uE000-\uE07F]/g;

/** One-line plain preview of a markdown note for list rows (TD-092). */
export function toPlainPreview(markdown: string): string {
  return markdown
    .split("\n")
    .map((line) =>
      line
        .replace(ESCAPED, (_, char: string) => String.fromCharCode(PARK + char.charCodeAt(0)))
        .replace(/\\$/, "")
        .replace(/^\s{0,3}#{1,6}\s+/, "")
        .replace(/^\s*[-*+]\s+\[[ xX]\]\s+/, "")
        .replace(/^\s*[-*+]\s+/, "")
        .replace(/^\s*\d+[.)]\s+/, "")
        .replace(/\*\*(.+?)\*\*/g, "$1")
        .replace(/\*(.+?)\*/g, "$1")
        .replace(PARKED, (parked) => String.fromCharCode(parked.charCodeAt(0) - PARK))
        .trim(),
    )
    .filter((line) => line.length > 0)
    .join(" · ");
}
